// UnseenOrdersProvider.js
import { createContext, useState, useContext } from "react";

const UnseenOrdersContext = createContext(null);

export function UnseenOrdersProvider({ children }) {
  const [unseenOrders, setUnseenOrders] = useState(0);

  const incrementUnseen = () => setUnseenOrders(prev => prev + 1);
  const resetUnseen = () => setUnseenOrders(0);

  return (
    <UnseenOrdersContext.Provider value={{ unseenOrders, incrementUnseen, resetUnseen }}>
      {children}
    </UnseenOrdersContext.Provider>
  );
}

export function useUnseenOrders() {
  const ctx = useContext(UnseenOrdersContext);
  if (!ctx) {
    throw new Error("useUnseenOrders must be used inside <UnseenOrdersProvider>");
  }
  return ctx;
}
